import React from "react";
import { FormattedMessage } from "react-intl";

import { homeworkSchedule } from "../../../../store/schedules";
import { SchedulerCategories } from "../schedulerCategories/SchedulerCategories";
import { useSchedulerContext } from "../SchedulerContext";
import { TRANSLATIONS } from "../scheduler.consts";
import { ScheduleRules } from "./scheduleRules/ScheduleRules";
import { SchedulerGrid } from "../schedulerGrid/SchedulerGrid";

export const ScheduleFormDescription = () => {
  const { type } = useSchedulerContext();

  return (
    <p className="schedule-form__description">
      <FormattedMessage id={TRANSLATIONS[type].description} />
    </p>
  );
};

export const SchedulerFormContent = () => {
  const { type } = useSchedulerContext();

  return (
    <div className={`schedule-form__content ${type}`}>
      <ScheduleRules />
      <SchedulerGrid />
      {homeworkSchedule(type) && <SchedulerCategories />}
    </div>
  );
};
